import { FC } from 'react'
import styled from 'styled-components'
import {
  border,
  BorderProps,
  shadow,
  ShadowProps,
  padding,
  layout,
  LayoutProps,
  PaddingProps,
  color,
  ColorProps,
} from 'styled-system'

export type ContentBlockProps = {
  width?: LayoutProps['width']
  maxWidth?: LayoutProps['maxWidth']
  bg?: ColorProps['bg']
  as?: 'div' | 'span'
  ref?: JSX.IntrinsicElements['div']['ref']
} & PaddingProps &
  BorderProps &
  ShadowProps

/**
 * A full width layout that centers it's children horizontally and limits their width.
 *
 * Inspired by the Braid design system
 *
 * https://seek-oss.github.io/braid-design-system/components/ContentBlock/
 */
const ContentBlock: FC<ContentBlockProps> = styled.div<ContentBlockProps>`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  ${padding}
  ${border}
  ${shadow}
  ${({ theme, bg }) => color({ theme, bg })}
  > * {
    ${({ width, maxWidth, theme }) => layout({ theme, width, maxWidth })};
  }
`

export default ContentBlock
